// src/components/EventGalleryCard.js

import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Chip } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

function EventGalleryCard({ event, onClick }) { // Added onClick prop
  if (!event) {
    return null; // Don't render if no event is passed
  }

  const formatDateTime = (date, allDay) => {
    if (!date) return 'TBD';
    const d = date; // FIXED: date is already a Date object, no need for .toDate()
    if (allDay) {
      return d.toLocaleDateString();
    } else {
      return d.toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' });
    }
  };

  return (
    <Card 
      sx={{ 
        maxWidth: 345, 
        minWidth: 280,
        margin: 'auto', 
        mt: 4, 
        mb: 2, 
        boxShadow: 3, 
        borderRadius: 2,
        cursor: 'pointer' // Added for visual feedback
      }}
      onClick={() => onClick(event)} // Applied onClick handler to the card
    >
      {event.imageUrl && (
        <CardMedia
          component="img"
          height="140"
          image={event.imageUrl}
          alt={event.title}
          sx={{ objectFit: 'cover' }}
        />
      )}
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography gutterBottom variant="h5" component="div">
            {event.title}
          </Typography>
          {event.isFeatured && (
            <Chip label="Featured" color="primary" size="small" variant="outlined" />
          )}
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <CalendarMonthIcon sx={{ mr: 1, fontSize: 'small' }} />
          <Typography variant="body2" color="text.secondary">
            {formatDateTime(event.start, event.allDay)}
            {event.end && event.start.getTime() !== event.end.getTime() && ` - ${formatDateTime(event.end, event.allDay)}`}
          </Typography>
        </Box>

        {event.location && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
            <LocationOnIcon sx={{ mr: 1, fontSize: 'small' }} />
            <Typography variant="body2" color="text.secondary">
              {event.location}
            </Typography>
          </Box>
        )}
        
        <Box sx={{ mt: 2 }}>
          {event.description && (
            <Typography variant="body2" color="text.secondary" noWrap>
              {event.description.substring(0, 100)}{event.description.length > 100 ? '...' : ''}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}

export default EventGalleryCard;